if (typeof window._lookport_player_log !== 'function'){
  window._lookport_player_log = (message) => {
    console.log('Lookport Player:',message)
  }
}
